import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment';
import { AUTHGWCONSTANTS } from '../../authorization/authconstatnts';
@Injectable({
  providedIn: 'root',
})
export class ShopService {
  public static dialogResult = false;
  headers: any;

  constructor(private http: HttpClient) {
    const xenAuth = localStorage.getItem(AUTHGWCONSTANTS.xenAuth);
    const guestAuth = localStorage.getItem(AUTHGWCONSTANTS.guestAuth);
    this.headers = { 'XEN-AUTHORIZATION': xenAuth ? xenAuth : guestAuth };
    this.headers = { ...this.headers, ...environment.platformInfo };
  }

  getOffers(urlParam: any): Observable<any> {
    return this.http.get<any>(environment.proxyApiUrl + '/api/components/offers', {
      headers: this.headers,
      params: urlParam,
    });
  }

  getProducts(urlParams: any): Observable<any> {
    return this.http.get<any>(environment.proxyApiUrl + '/api/component/product/v5', {
      headers: this.headers,
      params: urlParams,
    });
  }

  getBrands(): Observable<any> {
    return this.http.get<any>(environment.proxyApiUrl + '/api/components/brand/list', {
      headers: this.headers,
    });
  }

  getCategories(): Observable<any> {
    return this.http.get<any>(environment.proxyApiUrl + '/api/resource/category', {
      headers: this.headers,
    });
  }

  postWishlist(body: any): Observable<any> {
    return this.http.post<any>(environment.proxyApiUrl + '/api/v4/component/user/wishlist', body, {
      headers: this.headers,
    });
  }

  deleteWishlistItem(urlParam: any): Observable<any> {
    return this.http.delete<any>(environment.proxyApiUrl + '/api/v4/component/user/wishlist', {
      headers: this.headers,
      params: { id: urlParam.subProductId },
    });
  }

  getSingleProduct(id: string): Observable<any> {
    return this.http.get<any>(environment.proxyApiUrl + '/api/resource/product?id=' + id, {
      headers: this.headers,
    });
  }

  postProductInCart(body: any): Observable<any> {
    return this.http.post<any>(environment.proxyApiUrl + '/api/online/customer_cart_v5', body, {
      headers: this.headers,
    });
  }

  getParentCategories(): Observable<any> {
    return this.http.get<any>(`${environment.proxyApiUrl}/api/resource/parent/category`, {
      headers: this.headers,
    });
  }

  postOfferApply(body: any): Observable<any> {
    return this.http.post<any>(environment.proxyApiUrl + '/api/offer/item/add', body, {
      headers: this.headers,
    });
  }
}
